import React from "react";
import "./Group277.css";

function Group277(props) {
  const { src } = props;

  return (
    <div className="group-276 border-1px-black">
      <img className="more-than-1" src={src} />
    </div>
  );
}

export default Group277;
